import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/DBContext';

const InsertImageSection = ({ id, removeSection, onSave, initialValue = '' }) => {
    const { uploadImage } = useAuth();  // Assuming this is correctly imported from your DBContext
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [fileName, setFileName] = useState('');
    const [imageUrl, setImageUrl] = useState(initialValue);

    // Save initial value when component mounts
    useEffect(() => {
        if (initialValue) {
            onSave({ id, type: 'image', value: initialValue });
        }
    }, []);

    const handleFileChange = async (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            setFileName(selectedFile.name);

            // Automatically upload and save the image
            setUploading(true);
            try {
                const fileUrl = await uploadImage(selectedFile);
                setImageUrl(fileUrl);
                onSave({ id, type: 'image', value: fileUrl });
                // console.log('Image uploaded successfully: ', fileUrl);
            } catch (error) {
                console.error('Error uploading image:', error);
            } finally {
                setUploading(false);
            }
        }
    };

    return (
        <div className="card position-relative">
            <button type="button" className="close position-absolute" style={{ right: '10px', top: '10px', zIndex: 1 }} onClick={() => removeSection(id)}>&times;</button>
            <div className="body" style={{ paddingTop: '40px' }}>
                {imageUrl ? (
                    <div>
                        <img src={imageUrl} alt="Blog content" style={{ width: '100%', marginBottom: '10px' }} />
                        <p>Current image - Upload a new file to replace</p>
                    </div>
                ) : null}
                <input type="file" onChange={handleFileChange} />
                {file && <p>New file: {fileName}</p>}
                {uploading && <p>Uploading...</p>}
            </div>
        </div>
    );
};

export default InsertImageSection;
